var map = {
	"./avatar01.jpg": "17ce",
	"./avatar02.jpg": "7669",
	"./avatar03.jpg": "bfce",
	"./avatar04.jpg": "0488",
	"./avatar05.jpg": "9038",
	"./avatar06.jpg": "9d53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e21b";